<template>
	<div>
		<van-field :class="{penetrate:penetrate}"  :required="formCreateInject.rule.validate[0].required" :value="value"
			:label="formCreateInject.prop.title.title" :placeholder="placeholder" @input="change" :input-align="inputAlign"
			:type="inputprops.type" :readonly="disabled || readonly" @click="penetrate?preview:''" >
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
		</van-field>
		<component ref="componentRef" :is="penetrateComponentConfig.component" v-bind="penetrateComponentConfig.props"
			v-if="penetrateComponentConfig" />
	</div>
</template>
<script>
	import penetrate from '@_system/components/base/mixins/penetrate/penetrate.js'
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase,penetrate],
		props: {
			formCreateInject: {
				type: Object,
				default: () => {
					return null
				}
			},
			inputprops: {
				default: () => {
					return {
						type:'text',
						rows:2
					}
				}
			},
			value: {
				default: () => {
					return ''
				}
			},
			title: {
				type: String,
				default: () => {
					return ''
				}
			},
			type: {
				type: String,
				default: () => {
					return 'text'
				}
			},
			inputAlign: {
				type: String,
				default: () => {
					return 'right'
				}
			},
			// showPassword: {
			// 	type: String,
			// 	default: () => {
			// 		return false
			// 	}
			// }
		},
		data() {
			return {

			}
		},
		created() {


		},
		mounted() {
			// if (this.$slots.append) {
			// 	this.$refs.input.setAttribute('readonly', true)
			// }
		},
		watch: {
			// disabled(val) {
			// 	if (this.$slots.append && val) {
			// 		this.hiddenAppend()
			// 	}
			// },
			// readonly(val) {
			// 	if (this.$slots.append && val) {
			// 		this.hiddenAppend()
			// 	}
			// }
		},
		computed: {
			fieldrule() {
				return this.formCreateInject.rule
			}
		},
		methods: {
			change(val) {
				this.$emit('change', Object.hasOwn(val, 'value') ? val.value : val)
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
				if (this.el) {
					this.formCreateInject.api.validateField(this.formCreateInject.field)
				}
			},
		}
	}
</script>
